/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

$(function () {
  // Accessibility
  var accessibility = function () {
    var targetNodes = $('.js-product-single-swatch');
    var MutationObserver= window.MutationObserver || window.WebKitMutationObserver;
    var myObserver = new MutationObserver(mutationHandler);
    var config = {
      attributes: false,
      characterData: false,
      childList: true,
      subtree: true
    };
    var addAltTag = function (element) {
      $(element).find('img').each(function () {
        var $this = $(this);

        if (!$this.attr('alt')) {
          $this.attr('alt', '');
        }
      });
    };

    targetNodes.each(function () {
      myObserver.observe(this, config);
    });

    function mutationHandler(mutationRecords) {
      mutationRecords.forEach(function (mutation) {
        if (typeof mutation.addedNodes == 'object') {
          addAltTag('.kiwi-sizing-modal');
        }
      });
    }
  };
  accessibility();


  // Site Nav
  var siteNav = function () {
    var $window = $(window);
    var $trigger = $('.js-site-nav__trigger');
    var $productNav = $('.js-product-nav');

    var setProductNavHeight = function () {
      $productNav.each(function () {
        var $this = $(this);

        $this.closest('.js-expando__content').show();

        $this.css({
          'height': $window.innerHeight() - ($this.offset().top - $window.scrollTop()),
        });

        $this.closest('.js-expando__content').hide();
      });
    };

    $trigger.on('click', function () {
      var $body = $('body');

      if (!$body.hasClass('product-nav-is-open')) {
        setProductNavHeight();
      }

      $body.toggleClass('product-nav-is-open');
    });

    enquire.register('screen and (max-width: 767px)', {
      unmatch: function () {
        $('body').removeClass('product-nav-is-open');
      }
    });

    $window.on('resize', function () {
      setProductNavHeight();
    });
  }
  siteNav();

  // View Selector
  $('.js-view-selector').on('change', function () {
    var url = $(this).val();

	if (url) {
	    window.location = url;
	}

	return false;
  });
});
